module.exports = __webpack_public_path__ + "assets/81a3fcaa0357721e566769775cf4d476.png";